import React from "react";
import styled from "styled-components";
import { FixaSegmentedControl } from "@coworker/apprestructured/src/shared/wrappers/FixaSegmentedControl/FixaSegmentedControl";
import { ScannerTypeEnum } from "./scannerBottomButtonBarUtils";

const Container = styled.div`
  padding: 16px 24px;
  .white-background {
    background-color: white;
    border-radius: 40px;
  }
`;

interface RedirectButtonComponentPresentationProps {
  navigate: (index: ScannerTypeEnum) => void;
  activeScannerIndex: number;
  items: { label: string }[];
}

const RedirectButtonComponentPresentation: React.FC<
  RedirectButtonComponentPresentationProps
> = ({ activeScannerIndex, navigate, items }) => {
  return (
    <Container>
      <FixaSegmentedControl
        className="white-background"
        items={items}
        activeIndex={activeScannerIndex}
        size="medium"
        onClick={(_e, index) => {
          navigate(index as ScannerTypeEnum);
        }}
      />
    </Container>
  );
};

export default RedirectButtonComponentPresentation;
